// Where the page is scrolled to, around the filter row and the banner above the games
// (layouts/application).

// The page is scrolled past the filter row's place, the row pinned under the header
// (pinned_filters.js).
export const filtersPinned = (): boolean => document.querySelector('.filters__pinned') !== null;

const BANNER_FOLD = 250; // ms, _banner.scss

// Takes the page to the top, where the new results start - to #top rather than to the grid or the
// filters: the banner above them may fold with the change, which would shift them up past the
// viewport after the scroll. Changed from far down the page, the banner doesn't play its fold out:
// the page lands on it already in its new state.
export const jumpToTop = (): void => {
  const content = document.querySelector('.content_right');
  if (content && filtersPinned()) {
    content.classList.add('layout-jumped');
    window.setTimeout(() => content.classList.remove('layout-jumped'), BANNER_FOLD);
  }
  document.getElementById('top')?.scrollIntoView();
};
